<template>
  <v-data-table
    :headers="filteredHeaders"
    :items="itemsList"
    :footer-props="{
      showFirstLastPage: true,
      showCurrentPage: true,
      itemsPerPageText: 'Rodyti po:',
      itemsPerPageAllText: 'visi',
      itemsPerPageOptions: itemsPerPageOptions,
    }"
    :hide-default-footer="hideFooter"
    :items-per-page="pageSize"
  >
    <template #[`item.actions`]="{ item }">
      <el-table-action :item="item" @selectItem="selectAsmuo(item)" />
    </template>
    <template slot="loading">
      Kraunasi...
    </template>
    <template slot="no-results">
      Duomenų nėra
    </template>
    <template slot="no-data">
      Duomenų nėra
    </template>
    <template #[`footer.page-text`]="props">
      Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
      {{ props.itemsLength }}
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: 'ElAsmenysList',
  props: {
    asmenys: Array,
    tipas: String,
  },
  data() {
    return {
      itemsPerPageOptions: [5, 50, -1],
      pageSize: 5,
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'Asmens kodas',
          align: 'start',
          value: 'asm_asmens_kodas',
          hide: this.isFizinis,
        },
        {
          text: 'Pavadinimas',
          align: 'start',
          value: 'asm_pavadinimas',
          hide: this.isFizinis,
        },
        {
          text: 'ILTU kodas',
          align: 'start',
          value: 'asm_asmens_kodas',
          hide: !this.isFizinis,
        },
        {
          text: 'Vardas Pavardė',
          align: 'start',
          value: 'asm_pavadinimas',
          hide: !this.isFizinis,
        },
        {
          text: 'Gimimo data',
          align: 'start',
          value: 'asm_gimimo_data',
          hide: !this.isFizinis,
        },
        {
          text: 'Šalis',
          align: 'start',
          value: 'asm_vls_pavadinimas',
        },
        {
          text: 'Veiksmai',
          align: 'center',
          sortable: false,
          value: 'actions',
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    itemsList() {
      return this.asmenys.map(item => {
        item.canSelect = true
        return item
      })
    },
    hideFooter() {
      return this.itemsList.length <= 5
    },
    isFizinis() {
      return this.tipas === 'FIZ'
    },
  },
  methods: {
    selectAsmuo(item) {
      item.canSelect = false
      this.$emit('selectAsmuo', item)
    },
  },
}
</script>

<style lang="scss" scoped></style>
